const recapQueryKeys = {
  recapPreferences: (userId) => [
    "recap-preferences",
    userId
  ],
  recapPreferencesOptions: () => [
    "recap-preferences-options"
  ],
  recapForDate: (userId, date, field) => [
    "recap-for-dates-v2",
    userId,
    date,
    field
  ]
};

export { recapQueryKeys };
//# sourceMappingURL=recapQueryKeys.js.map
